import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CompanyContext } from "context";
import RevitParameterContainer from "../Parameters/RevitParameterContainer";

interface Props {
    handleClose: () => void;
}

const EditCompanyRevitParametersModalForm: React.FC<Props> = ({ handleClose }) => {
    const { t } = useTranslation();
    const { revitParameters, createRevitParameter, updateRevitParameter, deleteRevitParameter } = useContext(CompanyContext);

    return (
        <Modal show={true} onHide={handleClose} backdrop="static" scrollable size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("pages.FAST.settings.revit-parameters.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6 className="text-muted">{t("pages.FAST.settings.revit-parameters.subtitle")}</h6>
                <RevitParameterContainer
                    revitParameters={revitParameters}
                    createRevitParameter={createRevitParameter}
                    updateRevitParameter={updateRevitParameter}
                    deleteRevitParameter={deleteRevitParameter}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    {t("buttons.close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditCompanyRevitParametersModalForm;
